document.addEventListener('DOMContentLoaded', function () {
    window.elmahio = new Elmahio({
        apiKey: 'a789ddece0bd47fe83390b702f5713a9',
        logId: '0c8c2ece-3b83-4fe6-a872-d539bac76f97',
        breadcrumbs: true,
        onmessage: function (msg) {
            if (!CURRENT_VERSION) return;
            msg.version = CURRENT_VERSION;
        },
        filter: function(msg) {
            try {
                if(msg?.title) {
                    return (msg.title.toLowerCase().indexOf("ResizeObserver loop limit exceeded".toLowerCase()) >= 0 || msg.title.toLowerCase().indexOf("Identifier 'originalPrompt' has already been declared".toLowerCase()) >= 0);
                }
                return false;
            } catch (e) {
                return false;
            }
        }
    });
});